import React from 'react';

import CheckboxInput from 'components/CheckboxInput';
import useSameInstructorToggle from '../useSameInstructorToggle';

function SamePrimaryInstructorToggle() {
  const { areAllInstructorsSame, onToggle } =
    useSameInstructorToggle('primaryInstructor');

  return (
    <CheckboxInput
      checked={areAllInstructorsSame}
      className="full-width"
      onChange={onToggle}
    >
      Same for all
    </CheckboxInput>
  );
}

export default SamePrimaryInstructorToggle;
